import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { Campaign } from "../../models/campaign.model";

let DeleteAccountDialogController = {
    selector: "deleteAccountDialog",
    templateUrl:
        "/angular/components/cancel/delete-account-dialog.component.html",
    bindings: {
        currentUser: "=",
        selectedCampaign: "=",
    },
    controller: class DeleteAccountDialogController {
        // * bindings for typescript compiler *
        public currentUser: User;
        public selectedCampaign: string;
        // ************************************

        private __env;
        private dialog: DialogUtils;
        private campaignDataProvider: CampaignDataProvider;

        public selectedCampaignID: string;
        public campaigns = [];
        public selectedCampaigns = [];

        constructor(
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            __env: any
        ) {
            this.__env = __env;
            this.dialog = DialogUtils;
            this.campaignDataProvider = CampaignDataProvider;
        }

        $onInit() {
            this.selectedCampaignID = this.selectedCampaign;
            this.campaignDataProvider
                .allCampaigns()
                .then((allCampaigns: Campaign[]) => {
                    const campaigns = _.cloneDeep(allCampaigns);
                    angular.forEach(campaigns, (value: any) => {
                        if (this.selectedCampaignID || campaigns.length == 1) {
                            //if there is only one campaign, then select that one
                            if (
                                this.selectedCampaignID == value.campaignid ||
                                campaigns.length == 1
                            ) {
                                value.selected = true;
                            }
                        }
                        this.campaigns.push(value);
                    });
                    this.getSelectedCampaigns();
                });
        }

        getSelectedCampaigns() {
            const campaigns = [];
            angular.forEach(this.campaigns, (campaign) => {
                if (campaign.selected) {
                    campaigns.push(campaign);
                }
            });
            this.selectedCampaigns = campaigns;
            return campaigns;
        }

        confirm() {
            this.dialog.hide(this.getSelectedCampaigns());
        }

        cancel() {
            this.dialog.cancel();
        }
    },
};

angular
    .module("cancel")
    .component(
        DeleteAccountDialogController.selector,
        DeleteAccountDialogController
    );
